const DEV = "https://laundrygoapps.24livehost.com/v1"
const UAT = "https://laundrygoappsuat.24livehost.com/v1"
const LIVE = "https://laundryapp.24livehost.com/v1"
const MAIN_LIVE= "https://api.laundrygo.com.au/v1"
// const GOOGLE_API_KEY = "AIzaSyB5qN725yH3kJO-aPfsf4lsbNSpaFjohR8&libraries"
const GOOGLE_API_KEY = "AIzaSyAWZjAcfkw5mw3EAbSB1RUAOUERlAQzHL4"  //google api key given by client
const BASE_URL = MAIN_LIVE;
export { BASE_URL, DEV, GOOGLE_API_KEY, UAT, LIVE,MAIN_LIVE }


// const BASE_URL = UAT;
// export { BASE_URL, UAT }
// const UAT = "https://laundrygoappsuat.24livehost.com/v1"

// const PROD = "https://laundrygoapps.24livehost.com/v1"
// const BASE_URL = PROD;
// export { BASE_URL, PROD }